// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services {
  padding: 80px 0;
  background-color: var(--secondary-light);
}


.section-title {
  text-align: center;
  margin-bottom: 50px;
  font-size: 2rem;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.service-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-icon {
  width: 210px;
  height: 200px;
  margin: 0 auto 20px;
}

.service-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.service-card h3 {
  /* color: #0066cc; */
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.service-card p {
  color: #666;
  margin-bottom: 20px;
  font-size: 0.95rem;
}

.learn-more {
  color: #0A2463;
  text-decoration: none;
  font-weight: 500;
  display: inline-block;
  transition: color 0.3s;
}

.learn-more:hover {
  color: #004080;
}

@media (max-width: 768px) {
  .services {
    padding: 50px 0;
  }

  .services-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/services/services.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,wCAAwC;AAC1C;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".services {\n  padding: 80px 0;\n  background-color: var(--secondary-light);\n}\n\n\n.section-title {\n  text-align: center;\n  margin-bottom: 50px;\n  font-size: 2rem;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 30px;\n}\n\n.service-card {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  transition: transform 0.3s;\n}\n\n.service-card:hover {\n  transform: translateY(-5px);\n}\n\n.service-icon {\n  width: 210px;\n  height: 200px;\n  margin: 0 auto 20px;\n}\n\n.service-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.service-card h3 {\n  /* color: #0066cc; */\n  margin-bottom: 15px;\n  font-size: 1.3rem;\n}\n\n.service-card p {\n  color: #666;\n  margin-bottom: 20px;\n  font-size: 0.95rem;\n}\n\n.learn-more {\n  color: #0A2463;\n  text-decoration: none;\n  font-weight: 500;\n  display: inline-block;\n  transition: color 0.3s;\n}\n\n.learn-more:hover {\n  color: #004080;\n}\n\n@media (max-width: 768px) {\n  .services {\n    padding: 50px 0;\n  }\n\n  .services-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
